import React from 'react';
import { Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import UserService from 'src/services/UserService';
import singletonMysqlApis from 'src/services/IntanceMysqlApis';

const LogoutButton = () => {

    const handleLogout = () => {
        localStorage.clear();
        singletonMysqlApis.clearToken?.();
        UserService.doLogout();
    };

    return (
        <Button
            color="inherit"
            startIcon={<ExitToAppIcon />}
            onClick={handleLogout}
        >
            Salir
        </Button>
    );
};

export default LogoutButton;
